import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Form, OverlayTrigger, Row, Tooltip, Button, InputGroup, Accordion } from 'react-bootstrap';
import Account from './Account';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useInput from './useInput';
/* import classNames from 'classnames'; */
import usePagination from 'hooks/usePagination';
import Input from './Input';
import Background from 'components/common/Background';
import corner6 from 'assets/img/illustrations/corner-6.png';
import Pagination from 'components/common/Pagination';
import { Link } from 'react-router-dom';

const InputPagination = ({ data, perPage, onSubmitStatus }) => {
 const [currentPg, setCurrentPg] = useState(1);
 const {
  paginationState: {
   data: paginatedProject,
   totalItems,
   //itemsPerPage,
   currentPage,
   canNextPage,
   canPreviousPage,
   paginationArray
   //from,
   //to
  },
  nextPage,
  prevPage,
  goToPage
  //setItemsPerPage
 } = usePagination(data, perPage, currentPg);

 useEffect(() => setCurrentPg(currentPage), [currentPage]);

 return (
  <>
   <Accordion defaultActiveKey="0" className="g-3 mb-3">
    {paginatedProject?.map((product, index) => (
     <Input key={product._id} product={product} index={index} onSubmitStatus={onSubmitStatus} />
    ))}
   </Accordion>

   <Card>
    <Card.Body className="d-flex justify-content-center border-top">
     <Pagination
      pageIndex={currentPage}
      pageCount={totalItems}
      canNextPage={canNextPage}
      canPreviousPage={canPreviousPage}
      previousPage={prevPage}
      nextPage={nextPage}
      gotoPage={goToPage}
      paginationArray={paginationArray}
     />
    </Card.Body>
   </Card>
  </>
 );
};

const Inputs = () => {
 const { /* data, */ payments /* , isLoading */, onSubmitStatus } = useInput();
 const [isAsc, setIsAsc] = useState(true);
 /* const [sortBy, setSortBy] = useState('price'); */
 const [perPage /* , setPerPage */] = useState(5);
 const [/* layout, */ setLayout] = useState('list');

 /* const toggleLayout =  */ () => {
  setLayout(prevLayout => (prevLayout === 'list' ? 'grid' : 'list'));
 };

 /* useEffect(() => {
  productsDispatch({
   type: 'SORT_PRODUCT',
   payload: {
    sortBy,
    order: isAsc ? 'asc' : 'desc'
   }
  });
 }, [sortBy, isAsc]); */

 return (
  <>
   <Row className="g-3 mt-0">
    <Col lg={9}>
     <Card className="mb-3">
      <Card.Header className="position-relative">
       <div className="flex-grow-1 fs--2">
        <h5 className="mb-0 text-primary">Ofertas</h5>
        <p className="mb-0">Ajilice sus ofertas</p>
       </div>
       <Background image={corner6} className="d-none d-md-block bg-card" />
      </Card.Header>
      <Card.Body className="pt-0 pt-md-3">
       <Row className="g-3 align-items-center">
        <Col xs="auto" className="d-xl-none">
         <Button className="position-relative p-0" size="sm" variant="link">
          <FontAwesomeIcon icon="filter" className="fs-0 text-700" />
         </Button>
        </Col>
        <Col>
         <Form className="position-relative">
          <Form.Control
           type="search"
           placeholder="Search..."
           size="sm"
           aria-label="Search"
           className="rounded search-input ps-4"
          />
          <FontAwesomeIcon
           icon="search"
           className="fs--1 text-400 position-absolute text-400 start-0 top-50 translate-middle-y ms-2"
          />
         </Form>
        </Col>

        <Col xs="auto" className="col-md">
         <Row className="g-0 justify-content-end">
          <Col xs="auto" className="position-md-static position-absolute top-0 end-0 me-3 mt-3 mt-md-1">
           <Form as={Row} className="gx-2">
            <Col xs="auto" className="d-none d-lg-block">
             <small>Sort by:</small>
            </Col>
            <Col xs="auto">
             <InputGroup size="sm">
              <Form.Select
               className="pe-5"
               defaultValue="price"
               style={{ maxWidth: '6.7rem' }}
               //onChange={({ target }) => setSortBy(target.value)}
              >
               <option value="price">Price</option>
               <option value="rating">Rating</option>
               <option value="review">Review</option>
              </Form.Select>
              <InputGroup.Text as={Button} variant="link" className="border border-300 text-700" onClick={() => setIsAsc(!isAsc)}>
               <FontAwesomeIcon icon={isAsc ? 'sort-amount-up' : 'sort-amount-down'} />
              </InputGroup.Text>
             </InputGroup>
            </Col>
           </Form>
          </Col>

          <Col xs="auto" className="p-0">
           <Row className="g-2 align-items-center">
            <Col xs="auto mb-1 mb-md-0">
             <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: 'fixed' }}>Crear Orden</Tooltip>}>
              <Button as={Link} to="new" variant="link" className="text-primary px-1">
               <FontAwesomeIcon icon="shopping-cart" />
              </Button>
              {/* <Button
               size="sm"
               variant="falcon-default"
               className="fs--1 text-600 white-space-nowrap w-100"
               onClick={handleFavouriteClick}
              >
               <FontAwesomeIcon
                icon={isInFavouriteItems(_id) ? 'heart' : ['far', 'heart']}
                className={classNames({
                 'text-danger': isInFavouriteItems(_id)
                })}
               />
               <span className="ms-1 d-none d-lg-inline">{isInFavouriteItems(_id) ? 'Deseado' : 'Añadir a lista'}</span>
              </Button> */}
             </OverlayTrigger>
            </Col>
           </Row>
          </Col>
         </Row>
        </Col>
       </Row>
      </Card.Body>
     </Card>

     {payments.length ? (
      <InputPagination data={payments} perPage={perPage} onSubmitStatus={onSubmitStatus} />
     ) : (
      <Card className="bg-transparent shadow-none py-3">
       <Card.Body className="border-2 border-dashed border-400 border rounded text-center py-5">
        <div className="fs--1">
         <FontAwesomeIcon icon="exclamation-triangle" className="fs-6 mb-3" />
         <h5>¡No se han encontrado proyectos!</h5>
         <p className="mb-0">Su búsqueda no coincidió con ningún proyecto. Inténtalo de nuevo o crea un nuevo proyecto</p>
        </div>
       </Card.Body>
      </Card>
     )}
    </Col>
    <Col lg={3}>
     <div className="sticky-sidebar">
      <Account />
     </div>
    </Col>
   </Row>
  </>
 );
};

InputPagination.propTypes = {
 data: PropTypes.arrayOf(PropTypes.object),
 perPage: PropTypes.number,
 onSubmitStatus: PropTypes.func
};

export default Inputs;
